module.exports = __webpack_public_path__ + "img/hata no kokoro_sc2.17411070.png";